import { SvgIcon, type SxProps, type Theme, Tooltip } from "@mui/material";
import type { FC, ReactElement } from "react";

export const ProgramIcon: FC<{
  data?: string | ReactElement;
  title?: string;
  sx?: SxProps<Theme>;
  fontSize?: "small" | "large";
}> = ({ data, title = "", sx = {}, fontSize = "large" }) => (
  <Tooltip title={title}>
    {typeof data === "string" ? (
      <SvgIcon fontSize={fontSize} sx={sx}>
        {/* nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml */}
        <g dangerouslySetInnerHTML={{ __html: data }} />
      </SvgIcon>
    ) : data ? (
      data
    ) : (
      <SvgIcon fontSize={fontSize} sx={sx}>
        {" "}
      </SvgIcon>
    )}
  </Tooltip>
);
